/**
 * @author        calvin@zumper.com (Calvin Yau)
 * @copyright     Copyright (c) 2022, Zumper
 * @description  faq data meta reducer
 */

import type { FaqDataMetaType } from '@zcode/state-type'
import type { Values } from '@zcode/utility-types'
import { combineReducers } from 'redux'
import { type ExtractActions, handleActions } from 'redux-actions'

import type * as faqDataActions from '../actions'
import {
  CLEAR_FAQ_DATA,
  DONE_FETCHING_FAQ_DATA,
  ERROR_FETCHING_FAQ_DATA,
  START_FETCHING_FAQ_DATA,
} from '../constants/index'
type ActionTypes = ExtractActions<Values<typeof faqDataActions>>

export const metaReducer = combineReducers<FaqDataMetaType, ActionTypes>({
  error: handleActions(
    {
      [ERROR_FETCHING_FAQ_DATA]: (state, { payload }) => payload?.error || state,
      [CLEAR_FAQ_DATA]: () => null,
      [START_FETCHING_FAQ_DATA]: () => null,
    },
    null as FaqDataMetaType['error']
  ),
  fetching: handleActions(
    {
      [START_FETCHING_FAQ_DATA]: () => true,
      [CLEAR_FAQ_DATA]: () => false,
      [DONE_FETCHING_FAQ_DATA]: () => false,
    },
    false as FaqDataMetaType['fetching']
  ),
  fetchingKey: handleActions(
    {
      [START_FETCHING_FAQ_DATA]: (state, { payload }) => payload?.key ?? state,
      [CLEAR_FAQ_DATA]: () => null,
      [DONE_FETCHING_FAQ_DATA]: () => null,
    },
    null as FaqDataMetaType['fetchingKey']
  ),
  currentKey: handleActions(
    {
      [CLEAR_FAQ_DATA]: () => null,
      [DONE_FETCHING_FAQ_DATA]: (state, { payload }) => payload?.key ?? state,
    },
    null as FaqDataMetaType['currentKey']
  ),
})
